import { render } from "./ChatDetail.vue?vue&type=template&id=6882e2aa&scoped=true"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"

import "./ChatDetail.vue?vue&type=style&index=0&id=6882e2aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6882e2aa"]])

export default __exports__